define('shared/initializer/form/newHouseAdapters/mixins/ForgetPasswordable',[
    '$',
    'shared/remote/member/house',
    'shared/remote/efid/password/reset',
    '../../adapters/mixins/Ajaxable',
    'Promise'
], function(
    $,
    getMemberHouse,
    resetPassword,
    Ajaxable,
    Promise
){
    function Ctor() { }

    Ctor.prototype.doSubmit = function() {
        var me = this;
        var args = arguments;
        var $form = me.$form;
        var $usr = $form.find('[name="EmailOrUserName"]');
        var email = $usr.val();

        return Promise.resolve()
            .then(function(){
                return getMemberHouse({
                    email: email
                });
            })
            .then(function(memberHouse){
                if (memberHouse === getMemberHouse.NOT_EXIST) {
                    return Promise.resolve();
                }

                if (
                    memberHouse === getMemberHouse.OLD
                ) {
                    return Ajaxable.prototype.doSubmit.apply(me, args);
                }
                else {
                    // 'loginnh' and 'reregister' should be considered as new house
                    // redirect-ui will handle reregister users and redirect them
                    // into re-register (into old house) page
                    return resetPassword({email: email.trim()});
                }
            });
    };

    return Ctor;
});
